export function getUserState(user: any): "PUBLIC" | "RETURNING" | "AUTHENTICATED" {
  if (user) return "AUTHENTICATED";
  if (localStorage.getItem("rc_has_account") === "true") return "RETURNING";
  return "PUBLIC";
}

export function setUserHasAccount(): void {
  localStorage.setItem("rc_has_account", "true");
}

export function clearUserAccount(): void {
  localStorage.removeItem("rc_has_account");
}

/** Display as First L — never show full last name. */
export function formatNameFirstLastInitial(
  name: string | undefined | null,
  fallback = ''
): string {
  const cleaned = (name || '').trim();
  if (!cleaned) return fallback;

  const parts = cleaned.split(/\s+/);
  if (parts.length === 1) return parts[0];

  const first = parts[0];
  const lastPart = parts[parts.length - 1].replace(/\./g, '');
  if (!lastPart) return first;

  const initial = lastPart.charAt(0).toUpperCase();
  if (lastPart.length === 1) {
    return `${first} ${initial}`;
  }
  return `${first} ${initial}`;
}
